
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightSnow as ObiLightningLightSnowElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-snow.js';
 
 
 

 
 export const ObiLightningLightSnow = createComponent({
   react: React,
   tagName: 'obi-lightning-light-snow',
   elementClass: ObiLightningLightSnowElement,
   events: {
     
   }
  });
 
 